













import Vue from "vue";
import { UseModal } from "../root/modal";
import PremiumModal from "./PremiumModal.vue";
import PlansModal from "@/components/modals/plans-modal/PlansModal.vue";
import { delayBy } from "@/fp";
import { AppAnalytics } from "@/analytics";
export default Vue.extend({
  props: ["feature", "disable"],
  setup(props) {
    const showModal = async () => {
      AppAnalytics.report({
        component: "General",
        eventName: `Premium_icon_clicked[Featue:${props.feature}]`
      });
      if (props.disable) {
        return;
      }
      const res = await UseModal().show(
        PremiumModal,
        // @ts-ignore
        { key: props.feature }
      );
      if (res.type === "success") {
        await delayBy(400);
        UseModal().show(PlansModal);
      }
    };
    return {
      showModal
    };
  }
});
